import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) ? String(error.message) : 'Unknown error' };
  }

  componentDidCatch(error) {
    try {
      // eslint-disable-next-line no-console
      console.error('Fatal render error:', error);
    } catch (_) {}

    // If the app bundle/chunk failed to load (very common in WebViews with stale cache),
    // force a cache-busting reload once.
    const msg = (error && error.message) ? String(error.message) : '';
    const isChunkError =
      /ChunkLoadError/i.test(msg) ||
      /Loading chunk/i.test(msg) ||
      /Unexpected token </i.test(msg);

    if (isChunkError && !window.__didHardReload) {
      window.__didHardReload = true;
      const base = window.location.href.split('#')[0].split('?')[0];
      window.location.replace(base + '?reload=' + Date.now());
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial' }}>
          <h3 style={{ margin: '0 0 8px 0' }}>Something went wrong</h3>
          <div style={{ color: '#666', marginBottom: 12, whiteSpace: 'pre-wrap' }}>{this.state.message}</div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: '10px 12px', cursor: 'pointer' }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function installGlobalErrorHandlers() {
  if (window.__globalErrorHandlersInstalled) return;
  window.__globalErrorHandlersInstalled = true;

  const maybeHardReload = (message) => {
    const msg = message ? String(message) : '';
    const isChunkError =
      /ChunkLoadError/i.test(msg) ||
      /Loading chunk/i.test(msg) ||
      /Unexpected token </i.test(msg);

    if (isChunkError && !window.__didHardReload) {
      window.__didHardReload = true;
      const base = window.location.href.split('#')[0].split('?')[0];
      window.location.replace(base + '?reload=' + Date.now());
    }
  };

  window.addEventListener('error', (event) => {
    try {
      // eslint-disable-next-line no-console
      console.error('Global error:', event?.error || event?.message || event);
    } catch (_) {}
    maybeHardReload(event?.message || event?.error?.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    try {
      // eslint-disable-next-line no-console
      console.error('Unhandled promise rejection:', event?.reason);
    } catch (_) {}
    maybeHardReload(event?.reason?.message || event?.reason);
  });
}

installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
